module.exports = __webpack_public_path__ + "img/36_76.82194565.png";